import { Box } from "@mui/material";
import React from "react";
import HeaderBar from "./HeaderBar";
import Footer from "./Footer";

const LayoutContainer = ({ children }) => {
  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <HeaderBar />
      <Box flexGrow={1}>{children}</Box>
      <Footer />
    </Box>
  );
};

export default LayoutContainer;
